import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { LazyService } from 'src/app/lazy.service';
import { TranslatePipe } from 'src/modules/base/pipes/translate.pipe';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { UtilService,PositionObj } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

declare var Html5Qrcode: any;

@Component({
    selector: 'app-qr-scanner',
    templateUrl: './qr-scanner.component.html',
    styleUrls: ['./qr-scanner.component.scss'],
    standalone: false
})
export class QRScannerComponent implements OnInit, AfterViewInit, OnDestroy {
  html5QrcodeScanner: any; showCameraPopUp: boolean = false;
  device: any; _loadedLibraries: any = {};
  placeholderValue: any = ""; listOfCameras=<any>[];
  facingModeIndex:number=0;
  config:any = {loading:false}
  
  constructor(
    private util: UtilService,
    private alert: AlertsService,
    private loader: LoaderService,
    private _lazy: LazyService,
    private appService: AppService,
    private baseService: BaseService,
    private router: Router
  ) { }

 

  ngAfterViewInit() {

    this.checkscannerStatus();
  }

  checkscannerStatus() {
      this._lazy.loadScript("./assets/js/qr-code/qr-code.min.js").then((res) => {
        this._loadedLibraries['url'] = "./assets/js/qr-code/qr-code.min.js";
        this.checkCameraAfterScript$()
      })
  }

  checkCameraAfterScript$() {
    var _that = this;
    this.util.detectWebcam((res: any) => {
      if (res) {
        this.checkCameraPermission((result: any) => {
          
          if (result == "prompt") {
            _that.util.checkCameraAccessStatus(()=>{
              if(this.checkMobile()){
                this.facingModeIndex = 1;
              }
              this.getlistofCameras();
            })
          }else if (result == "denied") {
            // this.closePopup();
            _that.util.checkCameraAccessStatus()
            _that.device = "camera"
            _that.showCameraPopUp = true;
          } else {
            if(this.checkMobile()){
              this.facingModeIndex = 1;
            }
            this.getlistofCameras();
          }
        })
      } else {
        this.alert.error("No camera detected")
      }
    })
  }

  getlistofCameras() {
      this.startQrCodeScanner()
  }


  checkCameraPermission(callback) {
    var that = this;
    
      const permissionName = "camera" as PermissionName;
      navigator.permissions.query({ name: permissionName }).then(function (permissionStatus) {
        if (permissionStatus.state == 'prompt' || permissionStatus.state == 'denied') {
          if (!that.appService.checkNativeApp()) {
            that.alert.error("Please give permission to access Camera");
          }
          callback(permissionStatus.state)
        } else {
          callback(permissionStatus.state);
        }
      })
  }

  checkMobile(){
    return this.util.isMobile()
  }

  processData(data: any) {
    if(data.indexOf("KX_AUTH__")>-1){
      var dataL = data.split("__");
      this.loader.showSpinner();
      this.updateOtherSession(dataL[1]);
    }else{
      this.config.loading = false;
      this.alert.error("invalidqrcode")
    }    
  }

  getGeofenceLocations(source: any): PositionObj[] {
    if (source?.latitude == null || source?.longitude == null) {
      throw new Error("Latitude or longitude missing");
    }

    var latitudes = source.latitude.toString().split(',').map((latitude) => parseFloat(latitude.trim()));
    var longitudes = source.longitude.toString().split(',').map((longitude) => parseFloat(longitude.trim()));

    if (latitudes.length !== longitudes.length) {
      throw new Error("Latitude and longitude count mismatch");
    }

    if (latitudes.some((latitude) => isNaN(latitude)) || longitudes.some((longitude) => isNaN(longitude))) {
      throw new Error("Invalid latitude or longitude");
    }

    return latitudes.map((latitude, index) => {
      return {
        latitude: latitude,
        longitude: longitudes[index]
      };
    });
  }

  ngOnInit(): void {
    if(!this.appService.checkNativeApp()){
      this.back();
    }
  }


  ngOnDestroy(): void {
    let player: any = document.querySelector("#videoQRScanner");
    if (player && player.srcObject) {
      player.srcObject.getVideoTracks().forEach(track => track.stop())
      this.stopQrCodeScanning(()=>{})
    }
  }

  switchCamera(){
    this.facingModeIndex = this.facingModeIndex === 0? 1: 0;
    this.stopQrCodeScanning((res)=>{
      setTimeout(()=>{
        this.startQrCodeScanner()
      },200)
    })
  }

  stopQrCodeScanning(cb) {
    try{
      this.html5QrcodeScanner.stop().then((ignore) => {cb(true) }).catch((err) => { cb(false)});
    }catch(e){
      console.log(e);
      cb(false)
    }
    
  }

  startQrCodeScanner() {
    var that = this;
    const config = { fps: 10, qrbox: { width: 250, height: 250 } };

    this.html5QrcodeScanner = new Html5Qrcode("reader", { formatsToSupport: [ Html5QrcodeSupportedFormats.QR_CODE ] });
    this.html5QrcodeScanner.start(
      { facingMode: (this.facingModeIndex==1)?"environment":"user" },
      {
        fps: 10,    // Optional, frame per seconds for qr code scanning
        qrbox: { width: 256, height: 256 }  // Optional, if you want bounded box UI
      },
      (decodedText, decodedResult) => {
        if (decodedText && !this.config.loading) {
          this.config.loading = true;
          that.processData(decodedText)
        }
      })
  }

  updateOtherSession(id){
    this.stopQrCodeScanning(()=>{
     
        let obj = {
          "id": id
      }
      this.baseService.getGeoLocation().then((resp)=>{
        var posTarget:PositionObj = resp;
        if(posTarget?.latitude != null  && posTarget?.longitude != null ){
          var source:any = this.appService.getAccountConfigValueList();
          if(source?.latitude != null && source?.longitude != null && source?.perimeter != null){
            var inside = false;
            try {
              var locations = this.getGeofenceLocations(source);
              inside = locations.some((posSource) => {
                return this.util.isInsidePerimeter(posSource,posTarget,source.perimeter);
              });
            } catch(e) {
              this.alert.error("geoconfigerr")
              this.loader.hideSpinner();
              this.config.loading=false;
              this.back();
              return;
            }
            if(inside){
              this.baseService.action(obj, "APPROVE_REQ", "account-management", "auth_restriction", false).subscribe((res) => {
                  this.loader.hideSpinner();
                  if (res.errCode == -1) {
                    this.config.loading=false;
                      this.alert.error(res.message)
                  } else if (res.errCode == 0) {
                    this.alert.success("SUCCESS")
                  }
                  this.back();
              }, (err) => {
                this.loader.hideSpinner();
                this.config.loading=false;
                this.alert.error(err)
                this.back();
              })
            }else{
              this.alert.error("notinisdeperimter")
              this.loader.hideSpinner();
              this.config.loading=false;
              this.back();
            }
            
          }else{
            this.alert.error("geoconfigerr")
            this.loader.hideSpinner();
            this.config.loading=false;
            this.back();
          }
        }else{
          this.alert.error("geoerror")
          this.loader.hideSpinner();
            this.config.loading=false;
            this.back();
        }
        
      })
     
    })
    
  }
  back(){
    this.router.navigateByUrl("/");
  }

}

enum Html5QrcodeSupportedFormats {
  QR_CODE = 0
}
